<app-slide
  [mechanicalDisplacement]="!isMobile"
  [activated]="!!hotelPromos?.length"
  [quantityOfItems]="hotelPromos?.length"
  [slideWidth]="slideWidth">
  <div *ngFor="let promo of hotelPromos"
    class="slideHotelPromo__content"
    [style.width]="slideWidth + 'px'">
    <app-ds-generic-card
      [space]="genericCardSpaces.XXXSNano">
      <div #slideItem class="slideHotelPromo__card" (click)="selectHotelPromo(promo)">
        @if (promo.free_cancelation) {
          <div class="slideHotelPromo__free-cancellation">
            <app-ds-tag-highlight
              [type]="tagHighlightType.Protection"
              [title]="'HOTELS_MODULE.DETAIL_DESCRIPTION.FREE_CANCELLATION' | transloco">
            </app-ds-tag-highlight>
          </div>
        }
        <div class="slideHotelPromo__slide-img-carousel">
          @if (promo.breakfast_included) {
            <div class="slideHotelPromo__breakfast-included">
              <app-ds-tag-category
                [icon]="icons.Restaurant"
                [label]="('HOTELS_MODULE.DETAIL_DESCRIPTION.BREAKFAST_INCLUDED' | transloco) | capitalize">
              </app-ds-tag-category>
            </div>
          }
          <app-image
            [type]="typeImageHotel"
            [src]="promo.image_url"
            [borderRadius]="8"
            [dimension]="'x184'">
          </app-image>
        </div>
        <div class="slideHotelPromo__content-info">
          <div class="slideHotelPromo__basic-info-container">
            <div class="slideHotelPromo__box-content-hotel">
              <div class="slideHotelPromo__name">
                <app-ds-typography
                  [size]="fontSize.RG"
                  [fontFamily]="fontFamily.SemiBold"
                  [color]="fontColor.Primary"
                  [text]="promo.hotel_name"
                  [ellipsis]="false">
                </app-ds-typography>
              </div>
            </div>
            <div class="slideHotelPromo__box-content">
              <div class="slideHotelPromo__location">
                <app-ds-typography
                  [size]="fontSize.XXXS"
                  [fontFamily]="fontFamily.Regular"
                  [color]="fontColor.Secondary"
                  [text]="promo.zone"
                  [ellipsis]="true">
                </app-ds-typography>
              </div>
            </div>
            <div class="slideHotelPromo__box-content">
              <div class="slideHotelPromo__rating-content">
                <div class="slideHotelPromo__score-star">
                  <ng-container *ngFor="let star of getStars(promo.stars)">
                    <app-ds-icon
                      [icon]="icons.Star"
                      [size]="16"
                      [color]="iconFillColor.Special">
                    </app-ds-icon>
                  </ng-container>
                </div>
                <div class="slideHotelPromo__score">
                  <app-score-detail
                    [withBorder]="!!promo.stars"
                    [score]="promo.score">
                  </app-score-detail>
                </div>
              </div>
              @if (!hasAmmenities(promo.ammenities)) {
                <div class="slideHotelPromo__amenities">
                  <ng-container *ngFor="let amenity of hotelAmenities(promo.ammenities); last as isLast">
                    <img *ngIf="amenity"
                      class="slideHotelPromo__img-amenities"
                      loading="lazy"
                      onerror="this.style.display = 'none'"
                      [alt]="amenity"
                      [src]="imageAmenity(amenity) | baseImage: amenitiesBasePath"
                      [class.is-last]="isLast"/>
                  </ng-container>
                </div>
              }
            </div>
            @if (isMarriottPromo) {
              <div class="slideHotelPromo__box-content slideHotelPromo__marriott-bonvoy-banner">
                <app-ds-tag-product
                  [title]="'HOTELS_MODULE.MARRIOTT.TITLE' | transloco"
                  [subtitle]="'HOTELS_MODULE.MARRIOTT.SUBTITLE' | transloco"
                  [type]="tagProductType"
                  [branding]="brandingTagProduct">
                </app-ds-tag-product>
              </div>
            }
          </div>
        </div>
        <div class="slideHotelPromo__content-footer">
          <div class="slideHotelPromo__content-info-price">
            <div class="slideHotelPromo__divider">
              <app-ds-divider></app-ds-divider>
            </div>
            <div class="slideHotelPromo__box-content">
              <div class="slideHotelPromo__box-left">
                <div class="slideHotelPromo__content-tag">
                  <app-member-rate-tag [tagType]="tagType(promo)"></app-member-rate-tag>
                </div>
                <div class="slideHotelPromo__nights">
                  <app-ds-typography
                    [size]="fontSize.XXXS"
                    [fontFamily]="fontFamily.Regular"
                    [color]="fontColor.Secondary"
                    [text]="priceToNights(promo.nights) | transloco: { quantity: promo.nights }"
                    [ellipsis]="true">
                  </app-ds-typography>
                </div>
                @if (promo.sub_text) {
                  <div class="slideHotelPromo__sub-text">
                    <app-ds-typography
                      [size]="fontSize.XXXS"
                      [fontFamily]="fontFamily.Regular"
                      [color]="fontColor.Secondary"
                      [text]="promo.sub_text"
                      [ellipsis]="true">
                    </app-ds-typography>
                  </div>
                }
              </div>
              <div class="slideHotelPromo__box-right">
                <div class="slideHotelPromo__discount-section">
                  @if (promo.discount_percent > 0) {
                    <app-ds-tag-member
                      [size]="tagMemberSize"
                      [type]="tagMemberType"
                      [style]="tagMemberStyle"
                      [label]="textDiscount(promo)"
                      [strikethrough]="{ Value: (promo.price_from_before_discount | currencyFormat: promo.currency: null: false), Align: 'left', ShowIcon: false }">
                    </app-ds-tag-member>
                  }
                </div>
                <div class="slideHotelPromo__total-price">
                  <app-ds-typography
                    [size]="fontSize.XS"
                    [fontFamily]="fontFamily.SemiBold"
                    [color]="fontColor.Primary"
                    [text]="promo.price_from | currencyFormat: promo.currency: true"
                    [ellipsis]="false">
                  </app-ds-typography>
                </div>
              </div>
            </div>
            <app-benefit-cashback
              [totalPrice]="promo.price_from"
              [currencyCode]="promo.currency"
              [productReference]="promo.product_reference"
              [benefitViewType]="benefitViewType"
              [staticCmsPercentage]="promo.cashback_percent">
            </app-benefit-cashback>

            <app-benefits-installments
              [searchBy]="searchByDeeplink(promo?.deeplink)"
              [totalPrice]="promo.price_from"
              [currencyCode]="promo.currency"
              [isCMS]="true"
              [productReference]="promo.product_reference"
              (viewFinancialPartners)="toggleFinancialPartners($event, searchByDeeplink(promo?.deeplink))">
            </app-benefits-installments>
          </div>
        </div>
      </div>
    </app-ds-generic-card>
  </div>
</app-slide>
